module.exports = __webpack_public_path__ + "assets/media/trashBin.f790ea41.svg";